export default __webpack_public_path__ + "static/media/client15.cf79310e.jpg";